// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';


class CriticalSecurityCorrelationsPPTX extends Component {

  renderCorrelations() {
    return this.props.correlations.map((correlation, index) => (
      <li key={index}>
        {correlation.title}
      </li>
    ));
  }
  render() {
    return (
      <div className='analytics__critical-security-correlations-pptx' id='pptx_critical_security_correlations'>
        <ol>
          {this.renderCorrelations()}
        </ol>
      </div>
    );
  }
}

CriticalSecurityCorrelationsPPTX.propTypes = {
  correlations: PropTypes.array.isRequired
};

export default CriticalSecurityCorrelationsPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/CriticalSecurityCorrelationsPPTX.js